import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const Diff = () => {

    const { id, sha_ini, sha_fix } = useParams();

    const [reviewInfo, setReviewInfo] = useState({
        owner: null,
        name: null,
        pr_id: null,
        file: null,
        original_commit_on_comment: null,
        fix_commit: null,
        keywords: [],
        message: null
    });

    const [evalInfo, setEvalInfo] = useState({
        security: null,
        correct: null,
        comment: null
    });

    const [evalLeo, setEvalLeo] = useState({
        security: null,
        reason: null,
        correct: null,
        comment: null
    });

    const [evalJuan, setEvalJuan] = useState({
        security: null,
        reason: null,
        correct: null,
        comment: null
    });

    function eval_review() {
        let isSecurity = document.getElementById('isSecurity').value;
        let correct = document.getElementById('correct').value;
        let comment = document.getElementById('comment').value;

        if (isSecurity === 'Select' || correct === 'Select') {
            alert('Please fill all fields');
            return;
        }

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_diff', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                id: id,
                sha_ini: sha_ini,
                sha_fix: sha_fix,
                isSecurity: isSecurity === 'true',
                correct: correct === 'true',
                comment: comment
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Diff evaluated');
                } else {
                    alert('Error evaluating Diff');
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });

    }

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_diff/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReviewInfo(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_diff_solution/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setEvalInfo(data);
                if (data.security === null) document.getElementById('isSecurity').value = 'Select';
                else document.getElementById('isSecurity').value = data.security ? 'true' : 'false';
                if (data.correct === null) document.getElementById('correct').value = 'Select';
                else document.getElementById('correct').value = data.correct ? 'true' : 'false';
                document.getElementById('comment').value = data.comment;
            })
            .catch(error => {
                console.error("Error:", error);
            });
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_eval/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user"), reviewer: 'lcentellas'}),
        })
            .then(response => response.json())
            .then(data => {
                setEvalLeo(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_eval/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user"), reviewer: 'jalonsol'}),
        })
            .then(response => response.json())
            .then(data => {
                setEvalJuan(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [id, sha_ini, sha_fix]);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Review</h1>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{reviewInfo.owner}/{reviewInfo.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Pull Request:</h1>
                    <p>{reviewInfo.pr_id}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">File:</h1>
                    <p>{reviewInfo.file}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL originial:</h1>
                    <Link target="_blank" to={'https://github.com/' + reviewInfo.owner + '/' + reviewInfo.name + '/pull/' + reviewInfo.pr_id + '/files/' + reviewInfo.original_commit_on_comment}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{reviewInfo.owner}/{reviewInfo.name}/pull/{reviewInfo.pr_id}/files/{reviewInfo.original_commit_on_comment}
                        </p>
                    </Link>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL fix:</h1>
                    <Link target="_blank" to={'https://github.com/' + reviewInfo.owner + '/' + reviewInfo.name + '/pull/' + reviewInfo.pr_id + '/commits/' + reviewInfo.fix_commit}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{reviewInfo.owner}/{reviewInfo.name}/pull/{reviewInfo.pr_id}/commits/{reviewInfo.fix_commit}
                        </p>
                    </Link>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Keywords:</h1>
                    <p>{reviewInfo.keywords.join(', ')}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Message:</h1>
                    <p>{reviewInfo.message}</p>
                </div>

            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluation:</h1>
                </div>
                <div className="grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Is Security:</label>
                        <select id="isSecurity" className="w-full">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Correct:</label>
                        <select className="w-full" id="correct">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Comment:</label>
                        <textarea type="text" id="comment" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_review}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="grid md:grid-cols-2 gap-2 sm:grid-cols-1">
                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Eval Leo</h1>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Is Security:</h1>
                        <p>{evalLeo.security ? 'True' : 'False'}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Reason:</h1>
                        <p>{evalLeo.reason}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Correct:</h1>
                        <p>{evalLeo.correct ? 'True' : 'False'}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Comment:</h1>
                        <p>{evalLeo.comment}</p>
                    </div>

                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Eval Juan</h1>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Is Security:</h1>
                        <p>{evalJuan.security ? 'True' : 'False'}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Reason:</h1>
                        <p>{evalJuan.reason}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Correct:</h1>
                        <p>{evalJuan.correct ? 'True' : 'False'}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Comment:</h1>
                        <p>{evalJuan.comment}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Diff;